export function getAccountsEnabled(): boolean {
  try {
    return __ENABLE_ACCOUNTS__;
  } catch (err) {
    return false;
  }
}
